 <template>
  <div>
    <div v-if="tableData.length">
      <div class="setTable">
        <loading :isShow="$root.$children[0].isShowLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="policyNo">
            <a class="name" @click="toPolicyDetail(row)">{{ row.policyNo }}</a>
          </template>

          <template slot-scope="{ row }" slot="dangerDesc">
            <span>{{ row.dangerDesc }}</span>
            <Poptip
              trigger="hover"
              placement="top-start"
              transfer-class-name="my-poptip"
            >
              <div slot="content">
                <span>{{ row.dangerDesc }}</span>
              </div>
            </Poptip>
          </template>
        </Table>
      </div>

      <div class="pageBox">
        <Page
          :total="total"
          :current="pageNo"
          :page-size="pageSize"
          show-total
          @on-change="pageChange"
          style="text-align: center"
        />
      </div>
    </div>

    <no-data v-if="!tableData.length"></no-data>
  </div>
</template>
<script>
import filter from "@/api/filter";
export default {
  name: "detailClaimsRecord",
  props: ["id"],
  data() {
    return {
      filter,
      tableData: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      columns: [
        {
          title: "序号",
          type: "index",
          align: "center",
          minWidth: 70,
        },
        {
          title: "保单号",
          slot: "policyNo",
          minWidth: 240,
          align: "center",
        },
        {
          title: "理赔专员",
          key: "claimName",
          minWidth: 140,
          align: "center",
        },
        {
          title: "出险描述",
          width: 400,
          slot: "dangerDesc",
          align: "center",
          ellipsis: true,
        },
        {
          title: "是否成功",
          minWidth: 120,
          align: "center",
          render(h, params) {
            return <span>{params.row.isSuccess == "1" ? "是" : "否"}</span>;
          },
        },
        {
          title: "理赔金额",
          minWidth: 120,
          key: "settleMoney",
          align: "center",
        },
        {
          title: "处理结果描述",
          key: "settleResult",
          width: 400,
          align: "center",
          ellipsis: true,
        },
        {
          title: "报案时间",
          minWidth: 160,
          align: "center",
          render(h, params) {
            return (
              <span>
                {filter.filterTime(params.row.createTime, "YYYY-MM-DD HH:mm")}
              </span>
            );
          },
        },
        {
          title: "理赔结案时间",
          minWidth: 160,
          align: "center",
          render(h, params) {
            return (
              <span>
                {filter.filterTime(
                  params.row.settleResultTime,
                  "YYYY-MM-DD HH:mm"
                )}
              </span>
            );
          },
        },
      ],
    };
  },
  created() {
    this.getInsureList();
  },

  methods: {
    getInsureList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/customerBase/read/settleclaim/list",
        type: "POST",
        data: {
          customerId: this.id,
          pageSize: this.pageSize,
          pageNo: this.pageNo,
        },
      })
        .then((res) => {
          this.$root.$children[0].isShowLoading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch(() => {
          this.$root.$children[0].isShowLoading = false;
        });
    },

    // 保单详情
    toPolicyDetail(row) {
      console.log(row);
    },

    // 分页
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getInsureList();
    },
  },
};
</script>
 <style lang="scss" scoped>
/deep/ .setTable .ivu-table th .ivu-table-cell {
  font-size: 15px;
  font-weight: bold;
  color: #272933;
}
.name {
  border-bottom: 1px solid #2d8cf0;
}

.pageBox {
  margin-top: 20px;
}
</style>